import "../../components/welcomeScreen/welcomeWizard.scss";
import "./syncSettings.scss";

import { List } from "immutable";
import { map } from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import Icon from "../../components/interface/Icon";
import ModalBody from "../../components/modal/ModalBody";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalRow from "../../components/modal/ModalRow";
import { immutableRecords } from "../../types";
import treeUtils from "../../utils/tree";

class SyncUlyssesPreconfiguredPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expandedItems: List()
    };

    this.onItemToggled = this.onItemToggled.bind(this);
  }

  onItemToggled(itemId, state) {
    this.setState({
      expandedItems: state ? this.state.expandedItems.push(itemId) : this.state.expandedItems.filter(i => i !== itemId)
    });
  }

  render() {
    const { ulyssesTree, ulyssesSelectedItemId } = this.props;

    let hasUlyssesLink = false;

    let label = this.props.ulyssesWaitingForAuth
      ? "[Please authorize Aeon Timeline access within Ulysses application]"
      : ulyssesSelectedItemId
        ? "[Connecting to Ulysses...]"
        : "[Press Next to select main narrative folder]";
    let path = "Ulysses";

    if (ulyssesTree && ulyssesSelectedItemId && ulyssesTree.documents.has(ulyssesSelectedItemId)) {
      label = ulyssesTree.documents.get(ulyssesSelectedItemId).label;
      hasUlyssesLink = true;
      const breadcrumbs = treeUtils.findBreadcrumbsOfNode(ulyssesTree.documentTree, ulyssesSelectedItemId);
      breadcrumbs.pop(); // Remove last element
      const pathNames = ["Ulysses", ...map(breadcrumbs, id => ulyssesTree.documents.get(id).label)];
      path = pathNames.join(" > ");
    } else if (ulyssesTree && ulyssesSelectedItemId) {
      label = "[Previous sync folder not found]";
    }

    return (
      <ModalBody key="content">
        <ModalGroup label={`Your timeline is being synced with:`} className="syncPreconfiguredModalGroup">
          <ModalRow>
            <ModalField flex={0}>
              <Icon className="syncAppIcon" icon="ulysses" color="iconSoften" />
            </ModalField>
            <ModalField flex={0}>
              <div className="syncPathDiv">
                <div>
                  <div className="syncPathFilename">
                    {hasUlyssesLink ? (
                      <FormButton linkStyle={true} label={label} onClick={null} />
                    ) : (
                      <span>{label}</span>
                    )}
                  </div>
                  <div className="syncPathDirectory">
                    <span className="syncDirectoryPath">{path}</span>
                  </div>
                </div>
              </div>
            </ModalField>
          </ModalRow>
        </ModalGroup>
      </ModalBody>
    );
  }
}

SyncUlyssesPreconfiguredPage.propTypes = {
  ulyssesTree: PropTypes.instanceOf(immutableRecords.SyncRepresentationRecord),
  ulyssesWaitingForAuth: PropTypes.bool,
  ulyssesSelectedItemId: PropTypes.string.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  settingsChanged: PropTypes.bool.isRequired
};

export default SyncUlyssesPreconfiguredPage;
